import React, { useState } from 'react';
import { Card, Tabs } from 'antd';
import { FaBuilding, FaStethoscope, FaTools } from 'react-icons/fa';
import { AppstoreOutlined, ToolOutlined } from '@ant-design/icons';
import Clinics from '../Clinics/Clinics';
import Specializations from '../Specializations/Specializations';
import FacilitiesManagement from '../Facilities/Facilities';
import EquipmentsScreen from '../EquipMents/Equipments';

const CenterManagement = () => {
    const [activeTab, setActiveTab] = useState('clinics');

    const tabItems = [
        {
            key: 'clinics',
            label: (
                <span className="flex items-center gap-2">
                    <FaBuilding />
                    Clinics
                </span>
            ),
            children: <Clinics />,
        },
        {
            key: 'specializations',
            label: (
                <span className="flex items-center gap-2">
                    <FaStethoscope />
                    Specializations
                </span>
            ),
            children: <Specializations />,
        },
        {
            key: 'facilities',
            label: (
                <span className="flex items-center gap-2">
                    <AppstoreOutlined />
                    Facilities
                </span>
            ),
            children: <FacilitiesManagement />,
        },
        {
            key: 'equipments',
            label: (
                <span className="flex items-center gap-2">
                    <ToolOutlined />
                    Equipments
                </span>
            ),
            children: <EquipmentsScreen />,
        },
    ];

    return (
        <div className="min-h-screen bg-[#F7FCFD]">
            <div className="md:p-2">
                <Card className="shadow-lg border-0 bg-white/90 backdrop-blur-sm mt-6">
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={tabItems}
                    />
                </Card>
            </div>
        </div>
    );
};

export default CenterManagement;